import { DSCodeEditor } from './DSCodeEditor.js';

export { CodeEditorWithSchema, DSCodeEditor } from './DSCodeEditor.js';
export default DSCodeEditor;
